import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import "../css/EmployeeForms.css";
import { BASE_URL } from "../config";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const ResignedEmployee = () => {
  const [states, setStates] = useState([]);
  const [selectedState, setSelectedState] = useState("");
  const [employees, setEmployees] = useState([]);
  const tableRef = useRef();
  const navigate = useNavigate();

  useEffect(() => {
    fetch(`${BASE_URL}/api/states`)
      .then((res) => res.json())
      .then((data) => setStates(data))
      .catch((err) => console.error(err));
  }, []);

  useEffect(() => {
    if (selectedState) {
      fetch(`${BASE_URL}/api/employees?state_id=${selectedState}`)
        .then((res) => res.json())
        .then((data) => setEmployees(data))
        .catch((err) => console.error(err));
    }
  }, [selectedState]);

  const handlePrint = () => {
    const printContents = tableRef.current.innerHTML;
    const printWindow = window.open('', '', 'height=600,width=1000');
    printWindow.document.write('<html><head><title>Resigned Employees</title>');
    printWindow.document.write('<style>table { width: 100%; border-collapse: collapse; font-size: 11px; } th, td { border: 1px solid #ccc; padding: 5px; }</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(printContents);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  const handleExport = () => {
    const ws = XLSX.utils.json_to_sheet(employees);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Resigned Employees");
    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, "resigned_employees.xlsx");
  };

  return (
    <div className="employee-main-container">
      <Header />
      <Navbar />

      <div className="employee-content-container">
        <div className="employee-heading-container">
          <h2 className="employee-title">Resigned Employee</h2>
        </div>

        <div className="employee-filter-container">
          <label htmlFor="stateSelect">State:</label>
          <select
            id="stateSelect"
            className="employee-state-dropdown"
            value={selectedState}
            onChange={(e) => setSelectedState(e.target.value)}
          >
            <option value="">Select State</option>
            {states.map((state) => (
              <option key={state.id} value={state.id}>
                {state.name}
              </option>
            ))}
          </select>
        </div>

        <div className="employee-table-actions" style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginBottom: "10px" }}>
          <button onClick={handlePrint} style={{ background: "#007bff", color: "#fff", padding: "5px 10px", borderRadius: "5px", fontSize: "12px" }}>🖨 Print</button>
          <button onClick={handleExport} style={{ background: "#28a745", color: "#fff", padding: "5px 10px", borderRadius: "5px", fontSize: "12px" }}>📥 Export</button>
        </div>

        <div className="employee-table-container" ref={tableRef}>
          <table className="employee-table">
            <thead className="text-white">
              <tr>
                <th>S.No</th>
                <th>User Name</th>
                <th>Employee</th>
                <th>Gender</th>
                <th>Manager</th>
                <th>Division</th>
                <th>Designation</th>
                <th>State</th>
                <th>City</th>
                <th>Phone</th>
                <th>Email</th>
                <th>Address</th>
                <th>DOB</th>
                <th>Training Date</th>
                <th>Final Joining Date</th>
                <th>Confirm Date</th>
                <th>Resign Date</th>
                <th>Expel Network Date</th>
                <th>Left Date</th>
                <th>NOC Date</th>
              </tr>
            </thead>
            <tbody>
              {employees.length === 0 ? (
                <tr>
                  <td colSpan="20" style={{ textAlign: "center" }}>No resigned employees found.</td>
                </tr>
              ) : (
                employees.map((emp, index) => (
                  <tr key={emp.id}>
                    <td>{index + 1}</td>
                    <td>{emp.username}</td>
                    <td>{emp.first_name} {emp.last_name}</td>
                    <td>{emp.gender}</td>
                    <td>{emp.manager_name}</td>
                    <td>{emp.division}</td>
                    <td>{emp.designation}</td>
                    <td>{emp.state_name}</td>
                    <td>{emp.city_name}</td>
                    <td>{emp.mobile}</td>
                    <td>{emp.email}</td>
                    <td>{emp.address}</td>
                    <td>{emp.dob}</td>
                    <td>{emp.training_date}</td>
                    <td>{emp.final_joining_date}</td>
                    <td>{emp.confirm_date}</td>
                    <td>{emp.resign_date}</td>
                    <td>{emp.expel_network_date}</td>
                    <td>{emp.left_date}</td>
                    <td>{emp.noc_date}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default ResignedEmployee;
